import type { SignFolder } from "../types";

export function FolderGrid({
  folders,
  renameId,
  renameName,
  onRenameName,
  onOpen,
  onStartRename,
  onSaveRename,
  onCancelRename,
  onDelete,
}: {
  folders: SignFolder[];
  renameId: number;
  renameName: string;
  onRenameName: (v: string) => void;
  onOpen: (id: number) => void;
  onStartRename: (f: SignFolder) => void;
  onSaveRename: () => void;
  onCancelRename: () => void;
  onDelete: (f: SignFolder) => void;
}) {
  if (folders.length === 0) {
    return (
      <div className="sg-empty is-soft">
        <h2>Aucun dossier pour l’instant</h2>
        <p>Un dossier = un type de pièce. CDI, prestation, présence… puis les PDF dedans.</p>
      </div>
    );
  }

  return (
    <div className="sg-folder-grid">
      {folders.map((f) => (
        <article key={f.id} className="sg-foldercard">
          <button type="button" className="sg-foldercard__open" onClick={() => onOpen(f.id)}>
            <span className="sg-foldercard__tab" aria-hidden="true" />
            <span className="sg-foldercard__body">
              {renameId === f.id ? (
                <input
                  className="sg-foldercard__input"
                  value={renameName}
                  autoFocus
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => onRenameName(e.target.value)}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                    if (e.key === "Enter") onSaveRename();
                    if (e.key === "Escape") onCancelRename();
                  }}
                />
              ) : (
                <>
                  <strong>{f.name}</strong>
                  <small>
                    {f.doc_count} fichier{f.doc_count > 1 ? "s" : ""}
                  </small>
                </>
              )}
            </span>
          </button>
          <div className="sg-foldercard__tools">
            <button
              type="button"
              className="sg-iconbtn"
              aria-label={renameId === f.id ? "Enregistrer le nom" : `Renommer ${f.name}`}
              onClick={(e) => {
                e.stopPropagation();
                if (renameId === f.id) onSaveRename();
                else onStartRename(f);
              }}
            >
              {renameId === f.id ? (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12.5 10 17.5 19 7.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M15.2 5.2a1.7 1.7 0 0 1 2.4 0l1.2 1.2a1.7 1.7 0 0 1 0 2.4L9.4 18.2 5 19l.8-4.4Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                </svg>
              )}
            </button>
            <button
              type="button"
              className="sg-iconbtn is-del"
              disabled={f.doc_count > 0}
              title={f.doc_count > 0 ? "Dossier non vide — impossible de le supprimer." : `Supprimer ${f.name}`}
              aria-label={`Supprimer ${f.name}`}
              onClick={(e) => {
                e.stopPropagation();
                if (f.doc_count === 0) onDelete(f);
              }}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 7h14M10 7V5h4v2m-6 3v8m4-8v8M7 7l.8 12.2A1.5 1.5 0 0 0 9.3 21h5.4a1.5 1.5 0 0 0 1.5-1.8L17 7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </article>
      ))}
    </div>
  );
}
